import React from "react";
import { Redirect } from "react-router-dom";

import useAuth from "../../hooks/useAuth";
import { recomtestEmail } from "../../utils/commonUtils";

const RecommendationGaurd = ({ children }) => {
  const {
    isLoggedIn,
    user: { email },
  } = useAuth();
  if (!isLoggedIn) {
    return <Redirect to="/auth/login" />;
  }
  if (email && email === recomtestEmail) return <Redirect to="/404" />;

  return <React.Fragment>{children}</React.Fragment>;
};

export default RecommendationGaurd;
